import { configureStore, getDefaultMiddleware } from '@reduxjs/toolkit';
import { persistStore, persistReducer } from 'redux-persist';
import { rootPersistConfig, rootReducer, history } from './rootReducer';
import { routerMiddleware } from 'connected-react-router';
import { apiErrorMiddleware } from './errormiddleware';

// ----------------------------------------------------------------------

const store = configureStore({
  reducer: persistReducer(rootPersistConfig, rootReducer),
  middleware: getDefaultMiddleware({
    serializableCheck: false,
    immutableCheck: false
  })
    .concat(apiErrorMiddleware)
    .concat(routerMiddleware(history))
});

const persistor = persistStore(store);

export { store, persistor };
